module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img51.962ef098.jpg";